// extracted by mini-css-extract-plugin
export default {"grid":"LandingSeriesGrid_grid__CGq3T"};